import { DEFAULT_EXCLUDE_FALSY_TOOGLE, Model, TableOptions, Query, DEFAULT_HEATMAP_STATUS, DEFAULT_BENCHMARK_HEATMAP_TOOGLE } from '@hub-components';

export interface DiscoveryJson {
  name: string,
  public_uuid: string,
  query?: {},
  options?: TableOptions
}
export class Discovery extends Model {
  id: string;
  name: string;
  owner: string;
  editors: string[];
  updatedAt: Date;
  createdAt: Date;
  query: any;
  options: TableOptions = {
    dataOptions: {
      excludeFalsy: DEFAULT_EXCLUDE_FALSY_TOOGLE,
    },
    heatmapOptions: {
      enableHeatmap: DEFAULT_HEATMAP_STATUS,
      benchmarkHeatmap: DEFAULT_BENCHMARK_HEATMAP_TOOGLE,
    },
    resultsPerPage: { value: 10 },
  };

  tableQueries: Query[];
  benchmarkQueries: Query[];
  shareUuid: string;
  publicUuid: string;
  permissions: any;

  constructor(obj: Partial<DiscoveryJson> = {}, schema = null) {
    super(obj);
    if (obj['query']) {
      const query = obj['query'];
      query['schema'] = schema;
      query['dates'] = {
        startDate: Date.create(query['dates']['startDate']),
        endDate: Date.create(query['dates']['endDate']),
        dynamic: query['dates']['dynamic'],
        range: query['dates']['range'],
      };

      if (obj['options']) {
        const options = {
          ...obj.options,
          dataOptions: {
            ...obj?.options?.dataOptions,
          },
          heatmapOptions: {
            enableHeatmap: obj.options?.heatmapOptions?.enableHeatmap ?? DEFAULT_HEATMAP_STATUS,
            benchmarkHeatmap: obj.options?.heatmapOptions?.benchmarkHeatmap ?? DEFAULT_BENCHMARK_HEATMAP_TOOGLE,
          }
        };

        this.options = Object.merge(this.options, options);
      }
    }
  }

  asJson(): DiscoveryJson {
    const json = {
      name: this.name,
      public_uuid: this.publicUuid,
    };
    if (this.query) {
      json['query'] = {
        dataset: this.query.dataset,
        metrics: this.query.metrics,
        dimensions: this.query.dimensions,
        dimensionProperties: this.query.dimensionProperties,
        dates: {
          startDate: this.query.dates.startDate.format('{yyyy}-{MM}-{dd}'),
          endDate: this.query.dates.endDate.format('{yyyy}-{MM}-{dd}'),
          dynamic: this.query.dates.dynamic,
          range: this.query.dates.range,
        },
        order: this.query.order,
        benchmark: this.query.benchmark,
        filters: this.query.filters,
        drilldowns: this.query.drilldowns,
        advFilters: this.query.advFilters,
        metricFilters: this.query.metricFilters,
      };
    }

    if (this.options) {
      json['options'] = this.options;
    }
    return json;
  }
}
